"use client"

import clsx from "clsx"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import SizeGuideSlice from "~/components/slices/SizeGuideSlice"
import type { TSizeGuideSlice } from "~/components/slices/SizeGuideSlice/types"

type PanelContentProps = PropsWithClassName<{ items: Nullish<TSizeGuideSlice> }>

function PanelContent({ className, items }: PanelContentProps) {
  if (!items) return null

  return (
    <div className={clsx(className)}>
      <SizeGuideSlice {...items} withGrid={false} />
    </div>
  )
}

export default PanelContent
